import {put, select, take} from "redux-saga/effects"
import {LOCATION_CHANGED, push} from "redux-little-router"
import {REHYDRATE} from "redux-persist"

import {AppCreators as Creators} from "./redux"
import {getLang, cookie} from "../../utils"
import {vars} from "../../config"

export default function* startup(dispatch, _action) {
  // set language
  const state = yield select()

  const defaultLangCookie = cookie.get(vars.defaultLangCookieName)
  const defaultLang =
    defaultLangCookie.length === 0 ? vars.defaultLang : defaultLangCookie

  const fixedURL = state.router.pathname.replace(
    state.router.params.lang,
    defaultLang
  )

  if (state.router.params.lang === getLang(state)) {
    // change language or it useless at all for now
  } else {
    if (state.router.pathname === "/") {
      yield dispatch(push(`${state.router.pathname}${defaultLang}/`))
    } else {
      state.router.params.lang = getLang(state)
      yield dispatch(push(fixedURL))
    }
  }

  // wait for rehydrate before initial request
  yield take(REHYDRATE)

  // set language (action triggers fetching menus)
  const lang = getLang(state)
  yield put(Creators.setLanguage(lang))

  // check if token is available now
  if ((yield select()).login.token !== null) {
    yield put(Creators.fetchNotifications())
  }
}

export function* startupLocation(dispatch, {payload}) {
  // wait for rehydrate before changing initial location
  yield take(REHYDRATE)

  yield dispatch({
    type: LOCATION_CHANGED,
    payload
  })
}



// WEBPACK FOOTER //
// ./src/containers/App/startup.sagas.js